import SznLoginAuthorizationProvider from './SznLoginAuthorizationProvider';
import OauthProvider from './OauthProvider';

export default function authorizationTokenProviderFactory(scriptLoadTimeout) {
	// when client page add SznOauthTokenProvider object we want to use it
	if (window.SznOauthTokenProvider) {
		return new OauthProvider();
	}

	return new SznLoginAuthorizationProvider(scriptLoadTimeout);
}
